module.exports = __webpack_public_path__ + "static/img/Karl-Oloapu.0852166.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Karl-Oloapu.jpg
// module id = GB0y
// module chunks = 0